import { useMemo } from 'react';
import { TDR } from 'tdr-common';
import { buildEventResultsSearchFilters } from '../helpers/buildEventResultsSearchFilters';
import { SearchFilters } from '../routes/AvailabilityGuard';
import { useEventAvailability } from './useEventAvailability';

export type EventBookNowOnResultsResult = {
	searchFilters: Partial<SearchFilters> | null;
	isResolved: boolean;
	isLoading: boolean;
	hasNoAvailability: boolean;
};

type UseEventBookNowOnResultsOptions = {
	enabled?: boolean;
};

export function useEventBookNowOnResults(
	event: TDR.Event,
	tables: TDR.Table[],
	restaurantId: string,
	timezone: string | null | undefined,
	currentFilters: SearchFilters,
	options?: UseEventBookNowOnResultsOptions
): EventBookNowOnResultsResult {
	const enabled = options?.enabled !== false;

	const availability = useEventAvailability(
		event,
		tables,
		restaurantId,
		timezone,
		!enabled
	);

	const searchFilters = useMemo(() => {
		if (!enabled || availability.isLoading) {
			return null;
		}
		return buildEventResultsSearchFilters(
			event,
			tables,
			currentFilters,
			availability.firstDate,
			availability.firstTime
		);
	}, [
		enabled,
		availability.isLoading,
		availability.firstDate,
		availability.firstTime,
		event,
		tables,
		currentFilters
	]);

	const isLoading = availability.isLoading;
	const isResolved = !isLoading;
	const hasNoAvailability = isResolved && searchFilters === null;

	return {
		searchFilters,
		isResolved,
		isLoading,
		hasNoAvailability
	};
}
